var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        fill: _vm.svgColor,
        xmlns: "http://www.w3.org/2000/svg",
        id: "Layer_1",
        "data-name": "Layer 1",
        viewBox: "0 0 24 24",
        width: _vm.width,
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M21 4h-5V2c0-.553-.448-1-1-1h-6c-.552 0-1 .447-1 1v2H3c-1.657 0-3 1.343-3 3v12c0 1.657 1.343 3 3 3h18c1.657 0 3-1.343 3-3V7c0-1.657-1.343-3-3-3ZM9 2h6v2H9V2Zm12 17c0 .552-.448 1-1 1H3c-.552 0-1-.448-1-1V7c0-.552.448-1 1-1h18c.552 0 1 .448 1 1v12ZM15 9h-6c-.552 0-1 .448-1 1s.448 1 1 1h6c.552 0 1-.448 1-1s-.448-1-1-1Zm0 4h-6c-.552 0-1 .448-1 1s.448 1 1 1h6c.552 0 1-.448 1-1s-.448-1-1-1Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }